import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { CTABanner } from "../components/CTABanner";
import { getIcon } from "../data/site";
import { useSite } from "../context/ContentContext";

export default function Services() {
  const { services: SERVICES } = useSite();
  return (
    <div data-testid="services-page">
      <Seo title="Our Services" description="Explore Domaleo Enterprise services: Import & Export, IT Solutions, Agricultural Solutions, Logistics and General Supply in Ghana." />

      <section className="relative overflow-hidden pt-32 pb-20 lg:pt-40 lg:pb-28">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
        <div className="relative container-px mx-auto max-w-7xl">
          <Reveal>
            <p className="overline text-accent">Our Services</p>
            <h1 className="mt-3 max-w-3xl text-4xl sm:text-5xl font-bold tracking-tight text-white text-balance">
              Solutions engineered for growth and reliability
            </h1>
            <p className="mt-5 max-w-2xl text-lg text-slate-200 leading-relaxed">
              Five integrated service lines that help businesses source, build, grow, move and supply with confidence.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="container-px mx-auto max-w-7xl py-20 lg:py-28 space-y-8">
        {SERVICES.map((s, i) => {
          const Icon = getIcon(s.iconName);
          const reverse = i % 2 === 1;
          return (
            <Reveal key={s.slug}>
              <div className={`grid items-center gap-8 rounded-3xl border border-border bg-card p-5 lg:grid-cols-2 lg:p-8 ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="overflow-hidden rounded-2xl">
                  <img src={s.image} alt={s.title} className="h-64 w-full object-cover lg:h-80" />
                </div>
                <div className="px-2 lg:px-4">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary"><Icon className="h-6 w-6" strokeWidth={1.6} /></span>
                  <h2 className="mt-4 font-heading text-2xl sm:text-3xl font-semibold">{s.title}</h2>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{s.overview}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.capabilities.slice(0, 5).map((c) => (
                      <span key={c} className="rounded-full bg-surface px-3 py-1 text-xs font-medium text-foreground/80">{c}</span>
                    ))}
                  </div>
                  <Link to={`/services/${s.slug}`} data-testid={`services-detail-link-${s.slug}`} className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:scale-105">
                    View details <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          );
        })}
      </section>

      <CTABanner />
    </div>
  );
}
